import React from 'react'
import styled from 'styled-components'
import Button from 'components/Button'
import ConfirmationIcon from '../icons/Confirmation'

const DialogOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`

const DialogContent = styled.div`
  background: white;
  padding: 32px;
  border-radius: 12px;
  width: 500px;
  max-width: 90vw;
  text-align: center;
  max-height: 80vh;
  overflow-y: auto;
`

const IconWrapper = styled.div`
  margin-bottom: 24px;
`

const Title = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: #101828;
  margin-bottom: 16px;
`

const ResultSummary = styled.div`
  margin-bottom: 24px;
  text-align: left;
  padding: 0 12px;
`

const SuccessCount = styled.div`
  color: #027a48;
  margin-bottom: 8px;
  font-weight: 500;
`

const FailureSection = styled.div`
  margin-top: 8px;
`

const FailureTitle = styled.div`
  color: #b42318;
  font-weight: 500;
  margin-bottom: 8px;
`

const FailedEmail = styled.div`
  background: #fef3f2;
  padding: 8px 12px;
  border-radius: 4px;
  margin-bottom: 4px;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
`

const ErrorMessage = styled.span`
  color: #b42318;
  font-size: 12px;
  font-style: italic;
`

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 16px;
`

const SuccessDialog = ({ isOpen, onClose, responseData }) => {
  if (!isOpen) return null

  const responseObj = Array.isArray(responseData)
    ? responseData[0]
    : responseData


  const dataObj = responseObj?.data?.data || {}

  
  const failedUsers = dataObj.failedUsers || []
  const successfulStudentsCount =
    dataObj?.assessment_assigned_students?.[0]?.count || 0
  const emailSuccessCount = dataObj?.sendEmails?.successCount || 0
  const failedCount = failedUsers.length

  // Calculate successful users (total assigned minus failed)
  const actualSuccessCount = successfulStudentsCount - failedCount

  // //console.log('Response Data:', responseObj)
  // //console.log('Extracted Data:', dataObj)
  // //console.log('Failed Users:', failedUsers)
  // //console.log('Success Count:', actualSuccessCount)

  return (
    <DialogOverlay>
      <DialogContent>
        <IconWrapper>
          <ConfirmationIcon />
        </IconWrapper>
        <Title>Assessment successfully sent!</Title>

        <ResultSummary>
          {/* <SuccessCount>
            {actualSuccessCount} student{actualSuccessCount !== 1 ? 's' : ''}{' '}
            successfully assigned
          </SuccessCount> */}

          {emailSuccessCount > 0 && (
            <SuccessCount>
              {emailSuccessCount} email
              {emailSuccessCount !== 1 ? 's' : ''} successfully sent
            </SuccessCount>
          )}

          {failedUsers.length > 0 && (
            <FailureSection>
              <FailureTitle>
                {failedUsers.length} email{failedUsers.length !== 1 ? 's' : ''}{' '}
                failed:
              </FailureTitle>
              {failedUsers.map((user, index) => (
                <FailedEmail key={index}>
                  <div>{user.email}</div>
                  {/* <ErrorMessage>{user.error}</ErrorMessage> */}
                </FailedEmail>
              ))}
            </FailureSection>
          )}
        </ResultSummary>

        <ButtonWrapper>
          <Button.Primary text="Close" onClick={onClose} />
        </ButtonWrapper>
      </DialogContent>
    </DialogOverlay>
  )
}

export default SuccessDialog
